module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "",
      "center": true,
      "visible": _vm.particularsVisible
    },
    on: {
      "update:visible": function($event) {
        _vm.particularsVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "particulars-view"
  }, [_c('div', {
    staticClass: "descriptions-title-view"
  }, [_vm._v("\n      系统权限详情\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-view"
  }, [_c('div', {
    staticClass: "descriptions-item"
  }, [_c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("上级权限:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.handleTypeByValue(_vm.particularsData.parentId, _vm.permissionNodeOptions)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("权限类型:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.handleTypeByValue(_vm.particularsData.permissionType, _vm.permissionTypeOptions)) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("排序:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.sortIndex) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("权限路径:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.permissionPath) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("权限编码:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.permissionCode) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "descriptions-item-view"
  }, [_c('div', {
    staticClass: "descriptions-title"
  }, [_c('el-tag', {
    attrs: {
      "size": "medium"
    }
  }, [_vm._v("备注:")])], 1), _vm._v(" "), _c('div', {
    staticClass: "descriptions-value"
  }, [_vm._v("\n            " + _vm._s(_vm.particularsData.permissionRemark) + "\n          ")])])])])]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "size": "mini"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v("关闭")])], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-58d73abe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58d73abe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/platform/auth-permission/ItemParticulars.vue
// module id = 1290
// module chunks = 1